// extracted by mini-css-extract-plugin
export default {"root":"SassMobileToolbar__root--1zU4f","menu":"SassMobileToolbar__menu--12Orj","button":"SassMobileToolbar__button--3XfSg"};